import { API } from 'aws-amplify'
import { notifyBugsnag } from './bugsnag'
import { getPartner, getCareer } from '../graphql/queries'

// states
export const INITIAL = 'INITIAL'
export const DONE = 'DONE'

export const ERROR_GET_CAREER = 'ERROR_GET_CAREER'
export const ERROR_NO_ID = 'ERROR_NO_ID'
export const ERROR_CAREER_NOT_ACTIVE = 'ERROR_CAREER_NOT_ACTIVE'
export const ERROR_GET_PARTNER = 'ERROR_GET_PARTNER'
export const ERROR_SPACE_CREATED = 'ERROR_SPACE_CREATED'

// context
export const TALENTPOOL = 'TALENTPOOL'
export const SELECT = 'SELECT'
// export const ATTRACT = 'ATTRACT'

export const initializeApp = async ({ career_id, partner_id }) => {
  const result = { context: career_id ? SELECT : TALENTPOOL }

  if (career_id) {
    try {
      const {
        data: { getCareer: career }
      } = await API.graphql({
        query: getCareer,
        authMode: 'AWS_IAM',
        variables: { id: career_id }
      })

      if (!career) result.error_state = ERROR_GET_CAREER
      else if (career.status !== 'ACTIVE' || career.archived) {
        result.error_state = ERROR_CAREER_NOT_ACTIVE
      } else result.career = career
    } catch (err) {
      notifyBugsnag(err, 'getCareer')
      result.error_state = ERROR_GET_CAREER
    }
  }

  if (!partner_id && !result.career) return result

  try {
    const {
      data: { getPartner: partner }
    } = await API.graphql({
      query: getPartner,
      authMode: 'AWS_IAM',
      variables: { id: partner_id || result.career.partner_id }
    })

    if (!partner) result.error_state = ERROR_GET_PARTNER
    else result.partner = partner
  } catch (err) {
    notifyBugsnag(err, 'getPartner')
    result.error_state = ERROR_GET_PARTNER
  }

  return result
}
